import React from 'react'
// import ProfileIcon from '../ProfileIcon'
// import DropDownNotification from '../DropDownNotification'
// import CourseNavigation from '../CourseNavigation'
import {
  Layout,
  Card,
  Row,
  Col,
  Progress,
  Avatar,
  Button,
  Badge,
  Table,
  Tabs,
  Statistic,
  List,
  Tag,
  Menu,
  Dropdown,
  notification,
  Space,
  Typography,
  Input,
  Select
} from 'antd';
import {
  BookOutlined,
  TrophyOutlined,
  ClockCircleOutlined,
  UserOutlined,
  BellOutlined,
  SearchOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  StarOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../reducers/authReducer';
import { useHistory } from 'react-router-dom';
const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;


  // const userProfile = {
  //   name: "Dr. Sarah Johnson",
  //   role: "Senior Nurse",
  //   department: "Emergency Department",
  //   completionRate: 78,
  //   certifications: 12,
  //   avatar: null
  // };

const FlexedDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0 32px;
  background: #fff;
`

const AppHeader = ({ courseNavigation }) => {
    const menuItems = [
      { key: 'dashboard', icon: <BarChartOutlined />, label: 'Dashboard' },
      { key: 'courses', icon: <BookOutlined />, label: 'My Courses' },
      { key: 'certifications', icon: <TrophyOutlined />, label: 'Certifications' },
      { key: 'browse', icon: <SearchOutlined />, label: 'Browse Courses' },
      { key: 'team', icon: <TeamOutlined />, label: 'Team Progress' },
    ];

    const dispatch = useDispatch()
    const history = useHistory()
    
      const userProfile = useSelector((state) => state.auth.user)
    
      const clickHandler = ({ key }) => {
        if (key === 'SIGN_OUT') {
          dispatch(logout())
        } else if (key === 'PROFILE') {
          history.push('/app/profile')
        }
      }
  
    const userMenu = (
      <Menu onClick={clickHandler}>
        <Menu.Item key="PROFILE" icon={<UserOutlined />}>
          Profile Settings
        </Menu.Item>
        <Menu.Item key="settings" icon={<SettingOutlined />}>
          Preferences
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="SIGN_OUT" icon={<LogoutOutlined />}>
          Logout
        </Menu.Item>
      </Menu>
    );

  return (
     <Header style={{ 
          background: '#fff', 
          padding: '0 24px', 
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Title level={3} style={{ margin: 0 }}>
            {/* Dashboard */}
          </Title>
          
          <Space size="large">
            <Badge count={3}>
              <Button type="text" icon={<BellOutlined />} />
            </Badge>
            <Dropdown overlay={userMenu} placement="bottomRight">
              <Button type="text">
                <Space>
                  {/* <Avatar size="small" icon={<UserOutlined />} /> */}
                  <Avatar src={userProfile.photo} style={{ cursor: 'pointer' }}></Avatar>
                  {userProfile.name}
                </Space>
              </Button>
            </Dropdown>
          </Space>
        </Header>
  )
}
//   <FlexedDiv>
//     <Space>{courseNavigation && <CourseNavigation />}</Space>
//     <Space>
//       <DropDownNotification />
//       <ProfileIcon />
//     </Space>
//   </FlexedDiv>

export default AppHeader
